import { render } from "./inputWidget.vue?vue&type=template&id=12a33e4a&scoped=true"
import script from "./inputWidget.vue?vue&type=script&lang=js"
export * from "./inputWidget.vue?vue&type=script&lang=js"

import "./inputWidget.vue?vue&type=style&index=0&id=12a33e4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a33e4a"]])

export default __exports__